import { USER_TYPES, ROUTES } from "@/shared/constants";
import type { User } from "@/shared/types";

export function isOrganizationAccount(user: Pick<User, "account_type"> | null | undefined): boolean {
  return user?.account_type === USER_TYPES.ORGANIZATION;
}

export function getPostAuthPath(
  user: Pick<User, "account_type"> | null | undefined,
  fallback: string = ROUTES.LOBBY
): string {
  if (isOrganizationAccount(user)) return ROUTES.ORGANIZATION_HALL;
  return fallback;
}
